module.exports = {
  footerText: "fusionZone",
  dateFormat:"MMM DD,YYYY"
}
